import React from "react";
import "./Work.css";
import { BsArrowUpRightCircleFill } from "react-icons/bs";
import { Link } from "react-router-dom";

const Work = () => {
  return (
    <section className="sectionWork" id="work">
      <div className="workContainer">
        <h1 className="worksectionTitle">
          work<span className="dotcolor">.</span>
        </h1>
        <div className="workItemContainer">
          <div className="workitems">
            <div className="worknumndlink">
              <h2 className="workNumber">01</h2>
              <div className="workitemlinks">
                <Link
                  to="https://github.com/anupreethas/react-admin-dashboard-ui"
                  target="_blank"
                >
                  <BsArrowUpRightCircleFill className="workitemLinkdown" />
                </Link>
              </div>
            </div>
            <Link
              to="https://github.com/anupreethas/react-admin-dashboard-ui"
              target="_blank"
              className="anchorlink"
            >
              <h3 className="workItemTitle">Admin Dashboard</h3>
            </Link>

            <p className="workItemdescription">
              A tool for tracking user analytics and managing user accounts.
              Built with React, Material UI.
            </p>
          </div>

          <div className="workitems">
            <div className="worknumndlink">
              <h2 className="workNumber">02</h2>
              <div className="workitemlinks">
                <Link
                  to="https://github.com/anupreethas/skycast-weather-forecast-app"
                  target="_blank"
                >
                  <BsArrowUpRightCircleFill className="workitemLinkdown" />
                </Link>
              </div>
            </div>
            <Link
              to="https://github.com/anupreethas/skycast-weather-forecast-app"
              target="_blank"
              className="anchorlink"
            >
              <h3 className="workItemTitle">
                Weather App using OpenWeatherMap API
              </h3>
            </Link>

            <p className="workItemdescription">
              A weather app which displays the weather data of a particular
              location. Built with React and OpenWeatherMap API.
            </p>
          </div>
          <div className="workitems">
            <div className="worknumndlink">
              <h2 className="workNumber">03</h2>
              <div className="workitemlinks">
                <Link
                  to="https://github.com/anupreethas/personal-productivity-tool"
                  target="_blank"
                >
                  <BsArrowUpRightCircleFill className="workitemLinkdown" />
                </Link>
              </div>
            </div>
            <Link
              to="https://github.com/anupreethas/personal-productivity-tool"
              target="_blank"
              className="anchorlink"
            >
              <h3 className="workItemTitle">
                To-Do list using LocalStorage functionality
              </h3>
            </Link>

            <p className="workItemdescription">
              A simple app to manage your tasks. Built with React and
              LocalStorage for data persistence.
            </p>
          </div>
          <div className="workitems">
            <div className="worknumndlink">
              <h2 className="workNumber">04</h2>
              <div className="workitemlinks">
                <Link
                  to="https://www.behance.net/gallery/208546271/Craigslist-UI-Case-Study"
                  target="_blank"
                >
                  <BsArrowUpRightCircleFill className="workitemLinkdown" />
                </Link>
              </div>
            </div>
            <Link
              to="https://www.behance.net/gallery/208546271/Craigslist-UI-Case-Study"
              target="_blank"
              className="anchorlink"
            >
              <h3 className="workItemTitle">Craiglist Redesign</h3>
            </Link>

            <p className="workItemdescription">
              A redesigned version of Craigslist for a cleaner look and feel.
              Designed in Figma.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Work;
